import { useUserStore } from '@/store/app'
import snackbar from '@/utils/snackbar'
import { ref, watch } from 'vue'

/**
 *
 * @param {Function} fn 接口方法
 * @param {string} local 文件类型
 * @param {Boolean} loading
 * @returns
 */
const useDownload = (
  fn,
  local,
  loading,
  show = { value: true },
  total = { value: 0 }
) => {
  const store = useUserStore()
  const canDownLoad = ref(false)
  // 是否可以下载取决于loading和已经点击过下载按钮
  if (loading) {
    watch(loading, (newVal) => {
      canDownLoad.value = !newVal
    })
  }

  /**
   *
   * @param {object} params 下载接口参数
   */
  const clickDownload = (params) => {
    if (show && !show?.value && total?.value > 10000) {
      show.value = true
      return
    }
    show.value = false

    try {
      fn({
        userId: store.userInfo.wiwId,
        sheetName: local,
        ...params,
        pageNum: 1,
      })
      snackbar.download('已添加，请稍后至下载中心')
      canDownLoad.value = false
    } catch (e) {
      console.log(e)
    }
  }

  const getFileNameFromContentDisposition = (header) => {
    if (!header) return null

    // handle filename and filename*=UTF-8'' cases
    const filenameRegex = /filename\*?=(?:UTF-8''|")?([^";]+)/i
    const match = header.match(filenameRegex)

    return match ? decodeURIComponent(match[1]) : null
  }

  const download = async (url, cd) => {
    try {
      const filename = getFileNameFromContentDisposition(cd)
      const a = document.createElement('a')
      a.href = url // 文件地址
      a.download = filename // 文件名称
      a.style.display = 'none'
      // Append to body (required for Firefox)
      document.body.appendChild(a)
      a.click()
      // Remove from DOM after download
      setTimeout(() => {
        document.body.removeChild(a)
      }, 100)
    } catch (error) {
      console.error('Download trigger error:', error)
    }
  }

  return {
    clickDownload,
    download,
    canDownLoad,
  }
}

export default useDownload
